export default {
  dateRange: {
    timeZoneId: undefined,
    quickRangeSelector: 'Today',
    timeRange: null,
    isCustomRange: false
  },
  eventInsightsData: {
    allRecords: [],
    totalsRecord: {}
  },
  showLoader: false
};